import { Component, Input, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import EncryptStorage from 'encrypt-storage';
import * as moment from 'moment';
import { AuthService } from 'src/app/auth/auth.service';
import { DateRange, MomentHelper } from 'src/app/models/date';
import {  ProductOfferSearch } from 'src/app/models/productOffer';
import { emptyFields,offerTitle, StatusOptions, UserStatus, UserStatusText } from 'src/app/utilities/common-file';
import { CommonService } from 'src/app/utilities/common-service';
import { Messages } from 'src/app/utilities/message';
import { NzModalService, NzNotificationService } from 'src/app/utilities/ng-zorro-antd.module';
 import { NzTableData } from 'src/app/utilities/nz-table.adapter';
import { ProductService } from '../product.service';
export const encryptStorage = EncryptStorage('secret_key', {
  storageType: 'localStorage'
});
@Component({
  selector: 'app-product-offers',
  templateUrl: './product-offers.component.html'
})
export class ProductOffersComponent implements OnInit {
  loading=false;
  isValid=false;
  isVisible=false;
  isEdit=false;
  currencySymbol='';
  offerCount=0;
  data:any;
  createLoader=false;
  updateLoader=false;
  offerTitle = offerTitle;
  emptyField = emptyFields;
  merchantStatus = UserStatus;
  merchantStatusText = UserStatusText;
  @Input() selectedRow:any;
  @Input() isNewOrder:boolean;
  productOfferForm: UntypedFormGroup;
  showDownload:string ;
  selectedRateDateRange: Date[] = null;
  private tableData: NzTableData<ProductOfferSearch, any> = new NzTableData<ProductOfferSearch, any>(new ProductOfferSearch(), 'name',);
  constructor(
    private productOffersService:ProductService,
    private commonService: CommonService,
    private fb: UntypedFormBuilder,
    private authService: AuthService,
    private notification: NzNotificationService,
    private modal: NzModalService
  ) {
    this.initializeForm();
   }

  ngOnInit() { 
    this.data=this.selectedRow;
    this.tableData.search.status='';
     this.currencySymbol = encryptStorage.getItem('currencySymbol');
   this.refresh();
  }
  initializeForm(){
    this.productOfferForm = this.fb.group({
      id: [""],
      startTime: ["", Validators.required],
      endTime: ["", Validators.required],
      offerPrice:["",Validators.required],
      status: ["", Validators.required],
    });
  }
 // Get List of Products offers.
 refresh(startFromPageOne: boolean = true){
   this.loading = true;
  this.tableData.data = [];
  if (startFromPageOne) {
    this.tableData.pageIndex = 1;
  }
   this.tableData.search.mlpId = this.selectedRow.id;
   this.tableData.search.appCode = this.selectedRow.appCode;
   if(this.isNewOrder){
     this.tableData.search.status=UserStatus.Active
   }
   this.productOffersService.getProductOffersList(this.tableData).subscribe((response: any) => {
    this.loading = false;
    this.tableData.total = response.data.total;
    this.tableData.data = response.data.merchantLocationProductOffers;
    this.offerCount = this.tableData.data.length;
    // this.showDownload = Messages.downloadReport;
 }, () => {
   this.loading = false;
 });
}
 // For changing date range
 onUpdatedOnChange(range: any[]) {
  if (range.length <= 1) {
    return;
  }
  this.tableData.search.createdDate = MomentHelper.createDateRange(range);
  this.refresh();
}
// For date range reset
updateClear(range: any[]) {
  if (range.length <= 1) {
    this.tableData.search.createdDate = DateRange.empty();
    return;
}
}
  // For Page Index change
  onIndexChange(event) {
    this.tableData.pageIndex = event;
    this.refresh(false);
  }
  // For User Status
  getStatus(status) {
    return this.commonService.getStatus(status);
  }
  // For User Status Tag color
  getStatusColor(status) {
    return this.commonService.getStatusColor(status);
  }
  listProduct(){
    this.isEdit=false;
    this.isVisible = true;
     this.initializeForm();
    this.productOfferForm.controls.status.setValue(1);
  }
  handleCancel(){
    this.isVisible=false;
  }
  // For Update Confirmation popup
  updateOfferConfirm(data) {
    this.modal.confirm({
      nzTitle: 'Are you sure you want to update this Offer?',
      nzOkText: 'Yes',
      nzOkType: 'danger',
      nzOnOk: () => this.editOffer(),
      nzCancelText: 'No',
      nzOnCancel: () => console.log('Cancel')
    });
  }
  saveOffer(){
    this.validateDates();
    let price = this.productOfferForm.value.offerPrice;
    if(this.productOfferForm.valid && this.isValid && (price > 0)){
      this.createLoader=true;
      //this.changeDateFormat();
      const value ={
        mlpId:this.selectedRow.id,
        startTime:new Date(this.productOfferForm.value.startTime).toISOString(),
        endTime:new Date(this.productOfferForm.value.endTime).toISOString(),
        appCode: this.selectedRow.appCode,
        offerPrice:this.productOfferForm.value.offerPrice,
        status:this.productOfferForm.value.status
      }
      this.productOffersService.saveOffer(value).subscribe((response)=>{
        this.notification.success(Messages.saved, '', {
          nzKey: 'key'
        });
        this.isVisible=false;
        this.createLoader=false;
        this.refresh();
      },(error)=>{
      this.createLoader=false;
      })
    }
    else{
      if(!this.productOfferForm.valid){
        this.showErrorFields();
      }
      else if(price < 1){
        this.notification.error('Offer Price should always be greater than 0.', '', {
          nzKey: 'key'
          });
      }
    }
  }
  changeDateFormat(){
    this.onChangeStartDate(this.productOfferForm.value.startTime);
    this.onChangeEndDate(this.productOfferForm.value.endTime);
  }
  updateOffer(data){
    let selectedRow = data;
    this.isEdit=true;
    this.isVisible=true;
    this.productOfferForm.patchValue(selectedRow);
  }
  onChangeStartDate(event) {
    var sDate = new Date(event);
    var date = sDate.toISOString().split('T')[0];
    this.productOfferForm.controls.startTime.setValue(date);
  }
  onChangeEndDate(event) {
    var sDate = new Date(event);
    var date = sDate.toISOString().split('T')[0];
    this.productOfferForm.controls.endTime.setValue(date);
  }
  editOffer(){
     this.validateDates();
     let price = this.productOfferForm.value.offerPrice;
    if(this.productOfferForm.valid && this.isValid  && (price > 0)){
       this.updateLoader=true;
      let id=this.productOfferForm.value.id;
      //this.changeDateFormat();
      const value ={
        mlpId:this.selectedRow.id,
        startTime:new Date(this.productOfferForm.value.startTime).toISOString(),
        endTime:new Date(this.productOfferForm.value.endTime).toISOString(),
        offerPrice:this.productOfferForm.value.offerPrice,
        status:this.productOfferForm.value.status
      }
      this.productOffersService.editOffer(value,id).subscribe((response)=>{
        this.isEdit=false;
        this.notification.success(Messages.updated, '', {
          nzKey: 'key'
        });
        this.isVisible=false;
        this.updateLoader=false;
        this.refresh();
      },(error)=>{
       this.updateLoader=false;
      })
    }
    else{
      if(!this.productOfferForm.valid){
        this.showErrorFields();
      }
      else if(price < 1){
        this.notification.error('Offer Price should always be greater than 0.', '', {
          nzKey: 'key'
          });
      }
    }
  }
    // For Delete Confirmation popup
    deleteOfferConfirm() {
      this.modal.confirm({
        nzTitle: 'Are you sure you want to delete this Offer?',
        nzOkText: 'Yes',
        nzOkType: 'danger',
        nzOnOk: () => this.deleteOffer(),
        nzCancelText: 'No',
        nzOnCancel: () => console.log('Cancel')
      });
    }
  deleteOffer(){
    let id = this.productOfferForm.value.id;
   this.productOffersService.deleteOffer(id).subscribe((response)=>{
    this.notification.success(Messages.deleted, '', {
      nzKey: 'key'
    });
    this.isVisible=false;
    this.refresh();
   },(error)=>{

   })
  }
  validateDates(){ 
    const date = this.productOfferForm.value.startTime;
    const endDate = this.productOfferForm.value.endTime;
   const startDate = moment(date).add(15, 'm').toDate()
   const startDateTimeStamp = moment(startDate).valueOf();
   const endDateTimestamp = moment(endDate).valueOf();
   if (startDateTimeStamp > endDateTimestamp) {
     this.productOfferForm.controls.startTime.markAsDirty();
     this.productOfferForm.controls.endTime.markAsDirty();
     this.notification.error('End Date should be 15minutes ahead of Start Date', '', {
       nzKey: 'key'
     });
     this.isValid = false;
     return;
   }
   this.isValid=true;
}
   showErrorFields(){
      for (const i in this.productOfferForm.controls) {
        this.productOfferForm.controls[i].markAsDirty();
        this.productOfferForm.controls[i].updateValueAndValidity();
      }
      this.notification.error('Please fill All fields', '', {
        nzKey: 'key'
        });
   }
   handleOk(){

   }
}
